<template>
  <div class="list_index">
    <div class="head_projectScene">
      <div class="left">
        <el-radio-group
          v-model="device_status"
          class="radio-left"
          @change="adtiveNameChange"
          size="small"
        >
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="3">运行</el-radio-button>
          <el-radio-button label="2">故障</el-radio-button>
          <el-radio-button label="4">停机</el-radio-button>
          <el-radio-button label="1">离线</el-radio-button>
        </el-radio-group>
        <div style="display:inline-block;position:relative">
          <el-radio-group
            v-model="status"
            size="small"
            @change="search_type_change"
          >
            <el-radio-button :label="1">设备编号</el-radio-button>
            <el-radio-button :label="3">项目编号</el-radio-button>
            <el-radio-button :label="4">机型</el-radio-button>
            <el-radio-button :label="2">{{
              $t("serialNumber")
            }}</el-radio-button
            ><!--序列号-->
          </el-radio-group>
          <el-input
            v-model="switchValue"
            size="small"
            :placeholder="
              status == '1'
                ? '请输入设备编号'
                : status == '2'
                ? '请输入序列号'
                : status == '3'
                ? '请输入项目编号'
                : '请输入机型'
            "
            class="input"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-ss"
              @click="request"
            ></i>
          </el-input>
          <el-button type="primary" class="yl-button" @click="request(1)"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="right">
        <el-upload
          v-show="is_admin == 1"
          class="upload"
          ref="upload"
          accept=".xls,.xlsx"
          :multiple="false"
          :action="licenseUrl"
          :headers="uploadHeaders"
          :on-success="uploadSuccess"
          :show-file-list="false"
        >
          <el-button type="primary" class="mr10 yl-button h"
            >导入license</el-button
          >
        </el-upload>
        <el-popover placement="bottom" width="200" trigger="hover">
          <div>
            <span>获取经纬度链接</span
            ><el-link
              :underline="false"
              type="primary"
              href="https://lbs.amap.com/tools/picker"
              target="_blank"
              >https://lbs.amap.com/tools/picker</el-link
            >
          </div>
          <el-button
            type="primary"
            slot="reference"
            class="yl-button h"
            icon="el-icon-download"
            @click="exportPosition"
            >导出经纬度</el-button
          >
        </el-popover>
        <el-upload
          class="upload"
          ref="upload"
          accept=".xls,.xlsx"
          :multiple="false"
          :action="actionUrl"
          :data="data"
          :headers="uploadHeaders"
          :on-success="uploadSuccess"
          :show-file-list="false"
        >
          <el-button
            type="primary"
            class="ml0 yl-button h"
            icon="el-icon-upload2"
            >导入经纬度</el-button
          >
        </el-upload>
      </div>
    </div>
    <el-table
      stripe
      border
      :data="tableData"
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '1px' }"
      @row-dblclick="toDetailInfo"
    >
      <el-table-column
        label="设备编号"
        :width="factory_no_width"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <el-badge
            v-if="scope.row.status == 1"
            class="item"
            type="success"
            :is-dot="true"
          ></el-badge>
          <el-badge
            v-else-if="scope.row.status == 0"
            class="item"
            type="info"
            :is-dot="true"
          ></el-badge>
          <el-button type="text" @click="toDetailInfo(scope.row)">{{
            scope.row.factory_no
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="项目编号"
        align="center"
        prop="project_number"
        width="160"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        label="机型"
        align="center"
        prop="machine_model"
        width="130"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        label="运行状态"
        align="center"
        prop="device_status"
        :width="device_status_wadth"
      >
        <template slot-scope="scope">
          <el-tag
            type="success"
            effect="dark"
            v-if="scope.row.device_status != '1' && scope.row.run_status == '1'"
            >运行</el-tag
          >
          <el-tag
            type="warning item"
            effect="dark"
            v-if="
              scope.row.device_status != '1' && scope.row.shutdown_status == '1'
            "
            >故障</el-tag
          >
          <el-tag
            type="danger item"
            effect="dark"
            v-if="
              scope.row.device_status != '1' && scope.row.standby_status == '1'
            "
            >待机</el-tag
          >
          <el-tag
            type="danger item"
            effect="dark"
            v-if="scope.row.device_status == '4'"
            >停机</el-tag
          >
          <el-tag
            class="tag_alarm item"
            effect="dark"
            v-if="
              scope.row.device_status != '1' && scope.row.alarm_status == '1'
            "
            >报警</el-tag
          >
          <el-tag
            type="info"
            effect="dark"
            v-if="scope.row.device_status == '1'"
            >离线</el-tag
          >
        </template>
      </el-table-column>
      <!-- <el-table-column label="超级表" align="center" prop="template_name" width="130" :show-overflow-tooltip="true"></el-table-column> -->
      <el-table-column
        label="电机电流"
        align="center"
        prop="electricCurrent"
        width="150"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <p v-if="scope.row.electricCurrent">
            {{ scope.row.electricCurrent }} A
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="排气压力"
        align="center"
        prop="pressure"
        width="150"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <p v-if="scope.row.pressure">{{ scope.row.pressure }} Mpa</p>
        </template>
      </el-table-column>
      <el-table-column
        label="排气温度"
        align="center"
        prop="temperature"
        width="150"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <p v-if="scope.row.temperature">{{ scope.row.temperature }} ℃</p>
        </template>
      </el-table-column>
      <el-table-column
        label="客户信息"
        align="center"
        prop="terminal_user"
        width="320"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        label="所属区域"
        align="center"
        prop="addr"
        :show-overflow-tooltip="true"
      ></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="page"
        :page-size="size"
        :total="count"
        @current-change="changePage"
        @size-change="handleSizeChange"
        popper-class="select_bottom"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import privacyData from "@/utils/cityData.js";
import DataService from "@/api/data";
import DeviceTemplateService from "@/api/deviceTemplate";
import axios from "axios";
import mqtt from "mqtt";
export default {
  data() {
    const valiSerialNumber = (rule, value, callback) => {
      if (this.form.serialNumber === "") {
        callback(new Error("请输入序列号"));
      } else if (/^[a-zA-Z]{2}/.test(this.form.serialNumber) == false) {
        callback(new Error("序列号前两位必须为字母"));
      } else if (this.form.serialNumber.length != 15) {
        callback(new Error("序列号长度必须为15位"));
      } else if (/^[a-zA-Z]{2}(\d){13}/.test(this.form.serialNumber) == false) {
        callback(new Error("序列号前两位必须为字母后面必须为数字"));
      } else {
        callback();
      }
    };
    return {
      is_admin: 0, //是否是管理员0不是，1是
      factory_no_width: "", //设备编号宽度
      device_status_wadth: "", //设备状态宽度
      device_status: "3",
      client: "",
      factory_no: "", //设备编号
      project_number: "", //项目编号
      machine_model: "", //机型
      collector_no: "", //序列号
      formType: 0, //0是新增，1是修改
      privacyData: [],
      serialNumberList: [],
      addEquipmentName: "",
      equipmentName: "",
      templateList: [],
      reason: "",
      switchValue: "",
      // activeName:'-1',//-1全部 0离线 1在线
      status: 1,
      value: "",
      size: 10,
      tableData: [],
      page: 1,
      count: 0,
      checkList: [],
      dialogAdd: false,
      dialogEditGatewayName: false,
      data: {
        user_id: this.$store.state.user_id,
      },
      form: {
        getewayName: "",
        itemNo: "",
        serialNumber: "",
        user_id: "",
        customerEquipmentModel: "", //客户设备型号
        customer: "", //对应客户
        region: "",
      },
      editForm: {
        getewayName: "",
        itemNo: "",
        serialNumber: "",
        customerEquipmentModel: "", //客户设备型号
        customer: "", //对应客户
        user_id: this.$store.state.user_id,
      },
      addRules: {
        getewayName: [
          { required: true, message: "请输入设备编号", trigger: "blur" },
        ],
        itemNo: [
          { required: true, message: "请输入项目编号", trigger: "blur" },
        ],
        serialNumber: [
          { required: true, message: "请输入mqtt网关序列号", trigger: "blur" },
        ],
      },
      // editRules:{
      //   getewayName:[{ required: true,message: '请输入网关名称', trigger: 'blur' }],
      // }
    };
  },
  computed: {
    // serach_data(){
    //   let data = this.status == '1' ? this.factory_no :  this.status == '2'?this.collector_no:this.status == '3'?this.project_number:this.machine_model;
    //   return data;
    // },
    licenseUrl() {
      return process.env.NODE_ENV === "development"
        ? "api/projectsite/importGatewayAuthCode"
        : "/projectsite/importGatewayAuthCode";
    },
    actionUrl() {
      return process.env.NODE_ENV === "development"
        ? "api/map/importLatitudeAndLongitude"
        : "/map/importLatitudeAndLongitude";
    },
    downUrl() {
      return process.env.NODE_ENV === "development"
        ? "api/map/exportLatitudeAndLongitude"
        : "/map/exportLatitudeAndLongitude";
    },
    uploadHeaders() {
      return {
        Authorization: this.$store.state.token,
      };
    },
  },
  methods: {
    //搜索类型变化
    search_type_change() {
      this.switchValue = "";
    },
    handleSelect(item) {
      console.log(item);
    },
    querySearch(queryString, cb) {
      let results = [];
      DataService.queryItemNo({
        itemNo: queryString,
        user_id: this.$store.state.user_id,
      })
        .then((res) => {
          console.log(res);
          res.data.forEach((el) => {
            results.push({ value: el });
          });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
      cb(results);
    },
    //导出经纬度
    exportPosition() {
      axios({
        method: "get",
        url: this.downUrl,
        // headers里面设置token
        params: {
          user_id: this.$store.state.user_id,
        },
        // 二进制流文件，一定要设置成blob，默认是json
        responseType: "blob",
      })
        .then((res) => {
          const link = document.createElement("a");
          const blob = new Blob([res.data]);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", "用户经纬度.xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    //导入经纬度
    uploadSuccess(res, file, fileList) {
      console.log(file);
      if (res.code === 200) {
        this.$message.success("操作成功");
      } else {
        this.$message.error(res.msg);
      }
    },
    //重置表单
    resetForm() {
      this.form = {
        getewayName: "",
        itemNo: "",
        serialNumber: "",
        user_id: "",
        customerEquipmentModel: "",
        customer: "",
        region: "",
      };
    },
    //新增项目现场
    addGateway() {
      this.resetForm();
      this.formType = 0;
      this.dialogAdd = true;
    },
    //获取模板名称
    getDataList() {
      DeviceTemplateService.getDeviceTemplate({
        user_id: this.$store.state.user_id,
        isPaging: 0,
        page: 0,
        size: 0,
      })
        .then((res) => {
          this.templateList = res.data;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    //跳转项目现场详细信息页面
    toDetailInfo(e) {
      this.$router.push({
        path: "/detailInfo",
        query: {
          serial_number: e.collector_no,
          equipmentModel: e.machine_model,
          status: 0,
          geteway_name: e.factory_no,
          item_no: e.project_number,
          // region:e.addr,
          customer: e.terminal_user,
          stable: e.stable,
          device_rank: e.device_rank,
          id: e.id,
        },
      });
    },
    changePage(page) {
      this.page = page;
      this.request();
    },
    //获取项目现场数据
    request(page) {
      if (page) {
        this.page = page;
      }
      this.factory_no = "";
      this.collector_no = "";
      this.project_number = "";
      this.machine_model = "";
      if (this.switchValue) {
        switch (this.status) {
          case 1:
            this.factory_no = this.switchValue;
            break;
          case 2:
            this.collector_no = this.switchValue;
            break;
          case 3:
            this.project_number = this.switchValue;
            break;
          case 4:
            this.machine_model = this.switchValue;
            break;
        }
      }
      this.tableData = [];
      DataService.projectsiteData({
        user_id: this.$store.state.user_id,
        device_status: this.device_status,
        // status:'-1',
        page: this.page,
        size: this.size,
        user_token: this.$store.state.token,
        factory_no: this.factory_no,
        project_number: this.project_number,
        machine_model: this.machine_model,
        collector_no: this.collector_no,
      })
        .then((res) => {
          this.tableData = res.data.list;
          this.count = Number(res.data.count);
          // res.data.projectSiteList.forEach(el=>{
          //   this.serialNumberList.push(el.serial_number)
          // })
          // this.querySpecificDataBySerialNumbers()
        })
        .catch((err) => {
          this.$message.error(err.msaage);
        });
    },
    querySpecificDataBySerialNumbers() {
      DataService.querySpecificDataBySerialNumbers({
        serialNumbers: this.serialNumberList,
      })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          this.$message.error(err.msaage);
        });
    },
    xlh(e) {
      this.$router.push({
        path: "/gatewayData",
        query: {
          xlh: e.serial_number,
          name: e.geteway_name,
        },
      });
    },
    //根据项目现场名称和序列号查询
    swich() {
      DataService.getProjectsiteData({
        page: 1,
        size: this.size,
        status: this.status,
        online_status: 2,
        user_id: this.$store.state.user_id,
        getewayNameOrSerialNumber: this.switchValue,
      })
        .then((res) => {
          this.tableData = res.data.projectSiteList;
          this.count = res.data.count;
        })
        .catch((err) => {
          this.$message.error(err.msaage);
        });
    },
    handleSizeChange(val) {
      this.size = val;
      this.request();
    },
    //新增网关
    addProjectSite() {
      this.form.user_id = this.$store.state.user_id;
      if (this.form.region) {
        this.form.region = this.form.region.join(",");
      }
      this.$refs.add.validate((valid) => {
        if (valid) {
          if (this.formType == 0) {
            DataService.addProjectSite({
              ...this.form,
            })
              .then((res) => {
                this.$message.success("新增成功");
                this.resetForm("add");
                this.dialogAdd = false;
                this.request();
              })
              .catch((err) => {
                this.$message.error(err.message);
              });
          } else {
            DataService.updateSerialNumber({
              ...this.form,
            })
              .then((res) => {
                this.$message.success("修改成功");
                this.dialogAdd = false;
                this.request();
              })
              .catch((err) => {
                this.$message.error(err.message);
              });
          }
          this.resetForm();
        } else {
          this.$message.error("请检查必填项");
          return false;
        }
      });
    },
    canel() {
      this.dialogAdd = false;
      this.resetForm("add");
    },
    //全部 离线 在线状态变化
    adtiveNameChange(status) {
      this.page = 1;
      this.device_status = status;
      this.request();
    },
    editCanel() {
      this.dialogEditGatewayName = false;
      this.$refs.edit.resetFields();
    },
    //修改网关名称
    // editGatewayName(){
    //   this.$refs.edit.validate((valid)=>{
    //     if(valid){
    //       DataService.updateSerialNumber({
    //         ...this.editForm
    //       }).then(res=>{
    //         this.$message.success('修改成功')
    //         this.dialogEditGatewayName = false;
    //         this.request()
    //       }).catch(err=>{
    //         this.$message.error(err.message)
    //       })
    //     }else{
    //       this.$message.error("请检查必填项");
    //       return false;
    //     }
    //   })
    // },
    //点击修改名称
    edit(e) {
      this.form.getewayName = e.geteway_name;
      this.form.serialNumber = e.serial_number;
      this.form.itemNo = e.item_no;
      this.form.customerEquipmentModel = e.customer_equipment_model;
      this.form.customer = e.customer;
      if (e.region) {
        this.form.region = e.region.split(",");
      }
      this.formType = 1;
      this.dialogAdd = true;
    },
    //删除项目现场
    deleteProjectSite(val) {
      let _this = this;
      this.$confirm(
        '是否确认删除现场名称为"' + val.geteway_name + '"的数据项?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(function() {
        DataService.deleteProjectSite({
          user_id: _this.$store.state.user_id,
          serialNumber: val.serial_number,
        })
          .then((res) => {
            _this.$message.success("删除成功");
            _this.request();
          })
          .catch((err) => {
            _this.$message.error(err.message);
          });
      });
    },
    //取消删除项目现场
    handleClose(index) {
      // console.log(index)
      this.$refs[`popover-${index}`].doClose();
    },
    //复制文本
    copyText(data) {
      // 存储传递过来的数据
      let OrderNumber = data.collector_no;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    mqttMSG() {
      const options = {
        connectTimeout: 40000,
        clientId: "MQTT" + Math.random().toFixed(5),
        username: "yunliansuperuser",
        password: "public",
        clean: true,
      };
      this.client = mqtt.connect(this.$wssURL, options);
      if (this.client.connected) {
        this.client.end();
      }
      // mqtt连接
      this.client.on("connect", (e) => {
        console.log("连接成功:");
        this.client.subscribe(`sendMessage/#`, (error) => {
          if (!error) {
            console.log("订阅成功");
          } else {
            console.log("订阅失败");
          }
        });
      });
      // 接收消息处理
      this.client.on("message", (topic, message) => {
        // console.log("收到来自", topic, "的消息", message.toString());
        // console.log(JSON.parse(message.toString()));
        let data = JSON.parse(message.toString());
        this.tableData.forEach((el) => {
          if (el.collector_no == data.serialNumber) {
            this.$set(el, "electricCurrent", data.electricCurrent);
            this.$set(el, "pressure", data.pressure);
            this.$set(el, "temperature", data.temperature);
          }
        });
      });
      // 断开发起重连
      this.client.on("reconnect", (error) => {
        console.log("正在重连:", error);
      });
      // 链接异常处理
      this.client.on("error", (error) => {
        console.log("连接失败:", error);
      });
    },
  },
  mounted() {
    this.is_admin = sessionStorage.getItem("is_admin");
    if (window.screen.width > 2000) {
      this.factory_no_width = "340";
      this.device_status_wadth = "240";
    } else {
      this.factory_no_width = "200";
      this.device_status_wadth = "160";
    }
    this.request();
    this.getDataList();
    this.mqttMSG();
    this.privacyData = privacyData;
  },
  beforeDestroy() {
    this.client.end();
  },
  watch: {
    "editForm.customerEquipmentModel": {
      handler(newName, oldName) {
        this.templateList.forEach((el) => {
          if (el.equipment_model == this.editForm.customerEquipmentModel) {
            this.equipmentName = el.equipment_name;
          }
        });
      },
      immediate: true,
    },
    "form.customerEquipmentModel": {
      handler(newName, oldName) {
        this.templateList.forEach((el) => {
          if (el.equipment_model == this.form.customerEquipmentModel) {
            this.addEquipmentName = el.equipment_name;
          }
        });
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.head_projectScene {
  display: flex;
  justify-content: space-between;
  .left {
    width: 1200px;
    /deep/ .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0;
    }
    /deep/ .el-input__inner {
      border-radius: 0 4px 4px 0;
      height: 44px;
      border: 1px solid rgba(128, 197, 255, 0.4);
      border-left: none;
      background: linear-gradient(
        0deg,
        rgba(98, 115, 165, 0.2),
        rgba(0, 174, 255, 0)
      );
      color: #fff;
      font-size: 18px;
      padding-left: 58px;
    }
    .yl-button {
      margin-left: 270px;
    }
  }
}
.tip {
  font-size: 14px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  color: #fff !important;
  width: 22px;
  height: 22px;
  border-radius: 50%;
}
.tip1 {
  background: linear-gradient(
    0deg,
    rgba(0, 174, 255, 0.8),
    rgba(0, 174, 255, 0.5)
  );
  border: 1px solid #00d8ff;
}
.tip2 {
  background: linear-gradient(
    0deg,
    rgba(54, 255, 196, 0.38),
    rgba(54, 255, 196, 0.24)
  );
  border: 1px solid #36ffc4;
}
.tip3 {
  background: linear-gradient(
    0deg,
    rgba(128, 138, 144, 0.39),
    rgba(128, 138, 144, 0.25)
  );
  border: 1px solid #808a90;
}
.radio-left {
  margin-right: 50px;
}
.input {
  width: 258px;
  position: absolute;
}
.item {
  margin-right: 15px;
  margin-left: 15px;
  // margin-bottom: 2px;
  /deep/ .el-badge__content--info {
    background-color: #d9d9d9;
    width: 15px;
    height: 15px;
    border: none;
  }
  /deep/ .el-badge__content--success {
    width: 15px;
    height: 15px;
    border: none;
  }
  /deep/ sup {
    top: 0;
  }
}
.button {
  width: 100%;
  margin-top: 10px;
  .el-button {
    width: 100%;
  }
}
.el-icon-search {
  cursor: pointer;
}
.el-icon-search:hover {
  color: rgb(26, 25, 25);
}
.right {
  display: flex;
}
.text {
  font-size: 18px;
  color: #fff;
}
.h {
  height: 42px;
}
.select {
  width: 344px;
}
</style>
